module.exports = __webpack_public_path__ + "img/brands-pan-stars-top.png?30dbb0b2609d10cd21d43ddd23e50192";